import { motion } from 'framer-motion';
import { Container } from './styes';
import { Dispatch, SetStateAction } from 'react';

interface HeaderInterface {
  currentMonthBeingShow: 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10 | 11 | 12;
  currentYearBeingShow: number;
  handleDateModalShow: Dispatch<SetStateAction<boolean>>;
  isNfUploaded: boolean;
  isPaymentVoucherUploaded: boolean;
  handlePaymentVoucherModalShow: Dispatch<SetStateAction<boolean>>;
  nfDownloadLink?: string;
  paymentVoucherLink?: string;
}

export default function Header({
  currentMonthBeingShow,
  currentYearBeingShow,
  handleDateModalShow,
  isNfUploaded,
  isPaymentVoucherUploaded,
  handlePaymentVoucherModalShow,
  nfDownloadLink,
  paymentVoucherLink,
}: HeaderInterface) {
  const monthsMap = {
    1: 'Janeiro',
    2: 'Fevereiro',
    3: 'Março',
    4: 'Abril',
    5: 'Maio',
    6: 'Junho',
    7: 'Julho',
    8: 'Agosto',
    9: 'Setembro',
    10: 'Outubro',
    11: 'Novembro',
    12: 'Dezembro',
  };

  return (
    <motion.div
      initial={{ opacity: 0 }}
      whileInView={{ opacity: 1 }}
      viewport={{ once: true }}
      transition={{ delay: 0.1, type: 'tween', stiffness: 10 }}
    >
      <Container>
        <strong>
          {monthsMap[currentMonthBeingShow]}
          {' '}
          de
          {' '}
          {currentYearBeingShow}
        </strong>
        <div className="actionButtons">
          <button type="button" onClick={() => handleDateModalShow(true)}>
            Alterar mês
          </button>
          {isNfUploaded && (
            <a href={nfDownloadLink} target="_blank" download rel="noreferrer">
              Baixar NF-e
            </a>
          )}
          {!isPaymentVoucherUploaded && (
            <button type="button" onClick={() => handlePaymentVoucherModalShow(true)}>
              Enviar comprovante de pagamento
            </button>
          )}
          {isPaymentVoucherUploaded && (
            <a href={paymentVoucherLink} target="_blank" download rel="noreferrer">
              Baixar comprovante enviado
            </a>
          )}
        </div>
      </Container>
    </motion.div>
  );
}
